@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../tooltip/style.scss' as *;
@use '../@shared/button.mixin' as *;

@layer kol-component {
	@include kol-button-styles('kol-link');
	@include kol-button-styles('kol-button');

	.kol-toolbar {
		display: flex;
		flex-wrap: wrap;
		align-items: center;

		&--orientation-vertical {
			flex-direction: column;
			align-items: stretch;

			.kol-span {
				align-items: flex-start;
			}
		}

		&:focus-within {
			outline: 1px solid;
			outline-offset: 2px;
		}
	}
}
